import { Component, Vue } from 'vue-property-decorator'
import LoadingBar from '@core/components/LoadingBar.vue'
import { inject } from 'inversify-props'
import API from '@core/services/API'
import { isNull, isUndefined } from 'lodash/fp'
import { UIService } from '@core/services/UIService'
import { SharedVariable } from '@core/model/SharedVariable'

@Component({
  components: {
    LoadingBar
  }
})
export class SingpassLoginQRMixin extends Vue {
  @inject()
  private $api: API

  protected isLoading = false

  protected error: string

  uiService: UIService

  @inject()
  private sharedVariable: SharedVariable

  loadExternalScript (url: string) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.setAttribute('src', url)
      document.head.appendChild(script)

      script.addEventListener('error', reject)
      script.addEventListener('abort', reject)
      script.addEventListener('load', () => {
        resolve(script)
      })
    })
  }

  async created () {
    // take injected UIService and set it to local
    this.uiService = this.sharedVariable.uiService

    // if have error, show error and return
    this.error = this.$route.query.error as string
    if (this.error) {
      return
    }

    await this.checkLogin()

    console.log('Login page.')

    // parallel network call to reduce the total time
    Promise.all([
      this.$api.account.singpassSettings(),
      this.loadExternalScript(__SINGPASS_NDI_LIB_URL__)
    ])
      .then(([singpassSettings]) => {
        const authParams = {
          clientId: singpassSettings.clientId,
          redirectUri: singpassSettings.redirectUri,
          responseType: 'code',
          scope: 'openid'
        }

        const authParamsSupplier = () => {
          return {
            state: singpassSettings.state,
            nonce: singpassSettings.nonce
          }
        }

        const onError = (errorId: string, message: string) => {
          console.error(`onError. errorId:${errorId} message:${message}`)
        }

        const result = window.NDI.initAuthSession('qr-wrapper', authParams, authParamsSupplier, onError)
        console.log(result)
      })
  }

  async logout () {
    await this.$api.account.logout()
    await this.$store.dispatch('logout')
  }

  async checkLogin () {
    const login = await this.getAccountLogin()
    if (!isNull(login) && !isUndefined(login)) {
      console.log(`Welcome ${login.accountNames[0]}!`)
      const info = await this.getAccountInfo(login.accountID)
      const meta = await this.getAccountMeta(login.accountID)
      await this.$store.dispatch('login', { ...login, ...info, ...meta })

      // After the account info has been retrieved,
      // redirect the user to the page
      this.$emit('redirect', meta.systemrole)
    }

    this.isLoading = false
  }

  getAccountLogin () {
    return this.$api.account.loginGet()
      .then(response => {
        if (response && response.isLogin) {
          return response
        }
      })
      .catch(async error => {
        console.error('login.js: Exception', error)
        await this.uiService.alert.show({
          type: 'error',
          message: error
        })
      })
  }

  async getAccountInfo (accountId: string) {
    return await this.$api.account.loginInfoGet({
      accountID: accountId
    })
  }

  async getAccountMeta (accountId: string) {
    const response = await this.$api.account.loginMetaGet({
      _oid: accountId
    })
    return response.meta
  }
}
